module.exports = __webpack_public_path__ + "static/media/fs-assets.4646c553.png";